export const validateName = (name, field) => {
  if (!name) return `${field} is required`;
  if (name.length < 2) return `${field} must be at least 2 characters`;
  return "";
};

export const validateEmail = (email) => {
  if (!email) return "Email is required";
  if (!/\S+@\S+\.\S+/.test(email)) return "Invalid email";
  return "";
};

export const validateDOB = (dob) => {
  if (!dob) return "Date of birth required";
  return "";
};

export const validateGender = (gender) => {
  if (!gender) return "Select gender";
  return "";
};

export const validateAddress = (address) => {
  if (!address) return "Address required";
  return "";
};

export const validateCity = (city) => {
  if (!city) return "City required";
  return "";
};

export const validateState = (state) => {
  if (!state) return "State required";
  return "";
};

export const validateCountry = (country) => {
  if (!country) return "Country required";
  return "";
};

export const validateCivilId = (id) => {
  if (!id) return "Civil ID required";
  return "";
};

export const validateExpiryDate = (date) => {
  if (!date) return "Expiry date required";
  return "";
};

export const validateFile = (file, name) => {
  if (!file) return `${name} required`;
  return "";
};

export const validatePhone = (phoneNumber) => {
  if(!phoneNumber) return "phone number  is required";
  return "";
};

export const validateWhatsapp = (whatsAppNumber) => {
  if(!whatsAppNumber) return "whatsapp number is required";
  return "";
};

export const validatePostal = (zipcode) => {
  if(!zipcode) return "zipcode is required";
  return "";
};
